import { Component } from '@angular/core';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './app.accessdenied.component.html',
})
export class AppAccessdeniedComponent {

}
